module.exports = __webpack_public_path__ + "static/media/5. El ayer 1, Resina, rama de árbol y lino sobre madera, 122 x 94 cm, 2019 copy.6271ed33.png";